import { render, staticRenderFns } from "./PortfolioAddStockDialog.vue?vue&type=template&id=4e2ab09c&scoped=true&"
import script from "./PortfolioAddStockDialog.vue?vue&type=script&lang=js&"
export * from "./PortfolioAddStockDialog.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioAddStockDialog.vue?vue&type=style&index=0&id=4e2ab09c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2ab09c",
  null
  
)

export default component.exports